import React, { FC, useState } from "react";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import { Input } from "antd";
import "./searchBar.scss";

interface SearchBarProps {
  handleSearch: (e: any) => void;
  value?: string;
  visible?:boolean
}

const SearchBar: FC<SearchBarProps> = (props) => {
  const { handleSearch, value,visible } = props;
  const [isVisible, setVisible] = useState<boolean>();


  const handleInputChange = (e: any) => {
    e.persist();
    setVisible(e.type === "change");
    handleSearch(e.target.value);
  };

  return (
    <>
      <SearchOutlined
        onClick={() => setVisible(true)}
        className={isVisible || visible ? "search-border" : ""}
      />
      <Input
        allowClear
        onChange={handleInputChange}
        className={
          isVisible || visible ? "header-search-input width" : "header-search-input"
        }
        suffix={isVisible || visible ? <CloseCircleOutlined /> : ""}
        value={value}
      />
    </>
  );
};

export default SearchBar;
